import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0658c8b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-container" }
const _hoisted_2 = { class: "d-flex dasboard-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard-header-item" }, "Alocado x Realizado", -1))
const _hoisted_4 = { class: "dashboard-header-menus" }
const _hoisted_5 = { class: "dashboard-header-filters" }
const _hoisted_6 = { class: "btn-group" }
const _hoisted_7 = {
  class: "filter-btn",
  type: "button",
  id: "dropdownMenuClickableInside",
  "data-bs-toggle": "dropdown",
  "data-bs-auto-close": "outside",
  "aria-expanded": "false"
}
const _hoisted_8 = { class: "scroll-container" }
const _hoisted_9 = {
  key: 0,
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuClickableInside"
}
const _hoisted_10 = ["for"]
const _hoisted_11 = {
  key: 1,
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuClickableInside"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "dropdown-item" }, "Sem filtros disponíveis")
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scroll-container" }, "Aplicar Filtros", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scroll-container" }, "Limpar Filtros", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "date" }
const _hoisted_19 = { class: "dashboard-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_checkbox_component = _resolveComponent("checkbox-component")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter) => {
            return (_openBlock(), _createElementBlock("div", {
              key: filter.name,
              class: "filter-content"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(filter.name + _ctx.countfilters(filter.data)), 1),
                  _createVNode(_component_BaseIcon, {
                    name: "chevron-down-dark",
                    size: "8px"
                  })
                ]),
                (_ctx.getFilter(filter.data))
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFilter(filter.data), (option) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: option,
                          class: "li-item"
                        }, [
                          _createElementVNode("label", {
                            for: option.fullname,
                            class: "dropdown-item"
                          }, [
                            _createTextVNode(_toDisplayString(option.fullname) + " ", 1),
                            _createVNode(_component_checkbox_component, {
                              checked: option.selected,
                              onChanged: ($event: any) => (_ctx.changeSearchParams(filter.data, option.id)),
                              checkboxid: option.fullname
                            }, null, 8, ["checked", "onChanged", "checkboxid"])
                          ], 8, _hoisted_10)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("ul", _hoisted_11, _hoisted_13))
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("button", {
          class: "save-btn",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.applySearchParams()))
        }, _hoisted_15),
        _createElementVNode("button", {
          class: "clear-btn",
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearFilters()))
        }, _hoisted_17),
        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.currentFormattedDate), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_router_view)
    ])
  ]))
}